import { Box, Container, Grid, Typography } from "@mui/material";

const Terms = () => {
  return (
    <Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
      <Container>
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            color: "red",
          }}
        >
          Terms and <span style={{ color: "#FAD707" }}>Conditions</span>
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: "left",
            fontWeight: "500",
            color: "#333",
            mt: 2,
          }}
        >
          Review our Terms and Conditions to understand the rules, rights, and
          responsibilities governing the use of our services. By accessing our
          platform, you agree to comply with these guidelines. For any
          clarifications, please contact us.
        </Typography>

        <Grid container spacing={4} sx={{ mt: 1 }}>
          {/* 📍 General Terms */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ textAlign: "left", fontWeight: "bold", mb: 1 }}>
              General Terms
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "left", color: "#444" }}>
              By accessing the website or making a donation, users agree to
              comply with the Trust’s terms of service, governed by Indian laws.
              The Trust reserves the right to update these terms, with the
              latest version available on this page.
            </Typography>
          </Grid>

          {/* 📍 Privacy Assurance */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ textAlign: "left", fontWeight: "bold", mb: 1 }}>
              Privacy Assurance
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "left", color: "#444" }}>
              THIRUKADAIYUR SENAITHALAIVAR CHARITABLE Trust values and protects
              the privacy and personal data of users, ensuring that the
              information provided will be used solely to process donations and
              will not be shared beyond this purpose.
            </Typography>
          </Grid>

          {/* 📍 Content Ownership */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ textAlign: "left", fontWeight: "bold", mb: 1 }}>
              Content Ownership
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "left", color: "#444" }}>
              All website content, including graphics, blogs, images, logos,
              and software, is the exclusive property of THIRUKADAIYUR
              SENAITHALAIVAR CHARITABLE Trust. Unauthorized use is strictly
              prohibited and may result in legal action.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Terms;